export class SupportTicketsResponsesModel {
    Id: string;
    OwnerUid: string;
    Name: string;
    Message: string;
    TicketId: number;
    Date: Date;
}
